import { LuRefreshCw } from "react-icons/lu"
import { useErrorLog } from "~/hooks/useErrorLog"
import { Button } from "~/components/ui/button"
import { TitleHeader } from "./title-header"

interface ErrorProps {
  title?: string
  error?: unknown
  message?: string
  renderHeader?: boolean
}

export function ErrorFallback({ title = "Ошибка", error, message, renderHeader = false }: ErrorProps) {
  const text = message ?? (error instanceof Error ? error.message : "Что-то пошло не так")
  useErrorLog(error, text, "error-fallback")

  return (
    <div className={renderHeader ? "flex flex-col flex-1" : "flex flex-col h-dvh"}>
      {renderHeader && <TitleHeader title={title} />}
      <div className="flex-1 flex items-center justify-center p-m">
        <div className="flex flex-col items-center gap-m text-center text-muted-foreground">
          <p className="text-lg">{text}</p>
          <Button size="lg" onClick={() => location.reload()}>
            <LuRefreshCw />
            Обновить
          </Button>
        </div>
      </div>
    </div>
  )
}

export function HeaderedErrorFallback(props: { error: unknown }) {
  return <ErrorFallback renderHeader {...props} />
}

export function TitleErrorFallback({ error, message }: ErrorProps) {
  const text = message ?? (error instanceof Error ? error.message : "Что-то пошло не так")
  return <TitleHeader title={text} />
}
